import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ContactModal from "./ContactModal";

const ScrollToTop = () => {
  const { pathname } = useLocation(); // 👈 current route

  const [visible, setVisible] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalOpenedOnce, setModalOpenedOnce] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  // ✅ FORCE SCROLL TO TOP ON ROUTE CHANGE
  useEffect(() => {
    window.scrollTo(0, 0);
    setVisible(false);
    setOpenModal(false);
    setModalOpenedOnce(false);
    setLastScrollY(0);
  }, [pathname]);

  // SCROLL HANDLER
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const scrolledPercent = (scrollTop / docHeight) * 100;

      // Show scroll-to-top button on all pages
      setVisible(scrollTop > 300);

      // ✅ OPEN MODAL ONLY ON HOME PAGE
      if (
        pathname === "/" && // 👈 HOME PAGE CHECK
        scrolledPercent > 98 &&
        !modalOpenedOnce
      ) {
        setOpenModal(true);
        setModalOpenedOnce(true);
      }

      // Close modal when scrolling up
      if (scrollTop < lastScrollY && openModal) {
        setOpenModal(false);
      }

      setLastScrollY(scrollTop);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [pathname, modalOpenedOnce, lastScrollY, openModal]);

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {/* SCROLL TO TOP BUTTON (ALL PAGES) */}
      <a
        href="#"
        id="scroll-top"
        onClick={scrollToTop}
        className={`scroll-top d-flex align-items-center justify-content-center ${
          visible ? "active" : ""
        }`}
      >
        <i className="bi bi-arrow-up-short"></i>
      </a>

      {/* CONTACT MODAL (HOME PAGE ONLY) */}
      {pathname === "/" && (
        <ContactModal open={openModal} onClose={() => setOpenModal(false)} />
      )}
    </>
  );
};

export default ScrollToTop;
